// frontend/src/features/inventory/pages/InventoryHomePage.tsx
// Hub صفحه Inventory — لینک به تمام زیربخش‌ها

import { useNavigate } from "react-router-dom";

import { PageBanner } from "@/shared/components/PageBanner";

const SECTIONS = [
  {
    title: "قطعات و متریال‌ها (Materials)",
    description: "مدیریت خانواده متریال‌ها، کاتالوگ قطعات و ریویژن‌ها",
    path: "/inventory/materials",
    icon: "📦",
  },
  {
    title: "انبارها (Warehouses)",
    description: "مدیریت انبارها و ساختار مکان‌های ذخیره‌سازی",
    path: "/inventory/warehouses",
    icon: "🏭",
  },
  {
    title: "تراکنش‌های انبار (Stock)",
    description: "ثبت اسناد ورود، خروج، حواله و انتقال موجودی",
    path: "/inventory/stock",
    icon: "📊",
  },
  {
    title: "ردیابی قطعات (Lots)",
    description: "مدیریت محموله‌ها، لات‌ها و رهگیری قطعات",
    path: "/inventory/lots",
    icon: "🔖",
  },
  {
    title: "واحدهای اندازه‌گیری (UoM)",
    description: "تعریف و مدیریت واحدهای وزن، طول، تعداد و...",
    path: "/inventory/uom",
    icon: "📐",
  },
  {
    title: "تنظیمات چاپ (Labels)",
    description: "طراحی و مدیریت لیبل‌های چاپگر بارکد",
    path: "/inventory/label-settings",
    icon: "🖨️",
  },
  {
    title: "تخصیص تعلیقی (Pending)",
    description: "تخصیص دیرهنگام پالت‌ها به تراکنش‌های نامشخص",
    path: "/inventory/pending-allocations",
    icon: "⏳",
  },
  {
    title: "کاتالوگ‌های وضعیت و دپارتمان‌ها (Catalogs)",
    description: "مدیریت دلایل وضعیت پالت و دپارتمان‌های سازمانی مسئول",
    path: "/inventory/catalogs",
    icon: "📋",
  },
];


export function InventoryHomePage() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="داشبورد انبار و لجستیک (Inventory)"
        subtitle="مدیریت قطعات، انبارها، و تراکنش‌های کالا"
        icon="📦"
        helpLink="/help/inventory/inventory-home"
      />
      
      <div style={{ maxWidth: "100%", margin: "0" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "1.5rem",
          }}
        >
          {SECTIONS.map((s) => (
            <div
              key={s.path}
              className="brand-card-extand"
              style={{
                padding: "1.5rem",
                cursor: "pointer",
                textDecoration: "none",
                display: "block",
              }}
              onClick={() => navigate(s.path)}
            >
              <div style={{ fontSize: "2.2rem", marginBottom: "0.75rem" }}>
                {s.icon}
              </div>
              <h3 style={{ fontSize: "1.1rem", fontWeight: "800", color: "#007270", marginBottom: "0.5rem" }}>{s.title}</h3>
              <p style={{ color: "var(--color-text-main)", fontSize: "0.85rem", margin: 0 }}>
                {s.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}